import { render, staticRenderFns } from "./ExternalButtonGroup.vue?vue&type=template&id=6ff5a154&scoped=true&"
import script from "./ExternalButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ExternalButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./ExternalButtonGroup.vue?vue&type=style&index=0&id=6ff5a154&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5a154",
  null
  
)

export default component.exports